import { InjectionToken, Type } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldConfig } from '../models/field-config.model';

// contrato que cada componente de campo debe implementar
export interface FieldComponent {
  field: FieldConfig;
  control: FormControl;
}

// mapa tipo → componente
export interface FieldRegistryMap {
  [fieldType: string]: Type<FieldComponent>;
}

// token de inyección
export const FIELD_REGISTRY =
  new InjectionToken<FieldRegistryMap>('FIELD_REGISTRY');